import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../../components/global/layout';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import { useSelector } from 'react-redux';
import methodModel from '../../../methods/methods';
import rolesModel from '../../../models/roles.model';
import moment from 'moment';
import environment from '../../../environment';
import { IoDocumentAttach } from 'react-icons/io5';

const TransactionViewPage = (p) => {
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const { id, userId } = useParams();
  const [data, setData] = useState();
  const [Permissions, setPermission] = useState({});
  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`transaction`, { user_id: did }).then((res) => {
      if (res.success) {
        console.log(res,"paaaaaaaaaaaaadddddddd")
        setData(res.data);
        
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);
  const downloadFile = async (pdfUrl) => {
    loader(true);
    try {
      const response = await fetch(`${environment.api}documents/${pdfUrl}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'documents.pdf');
      document.body.appendChild(link);
      link.click();
      loader(false);
      link.parentNode.removeChild(link);
      loader(false);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      loader(false);
    }
  };
  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              View Transactions
            </h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about customer Transactions
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Title</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.title)}
            </div>
          </div>

          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Category</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data &&
                methodModel.capitalizeFirstLetter(data?.category_id?.name)}
            </div>
          </div>

          {/* <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">C</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && moment(data?.createdAt).format('DD-MM-YYYY')}
            </div>
          </div> */}
          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Description</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              <div dangerouslySetInnerHTML={{ __html: data?.description || "---" }}>
                {/* {data && data?.description} */}
              </div>
            </div>
          </div>
          {data?.document?.length > 0 ? (
            <div className="col-span-12 md:col-span-6">
              <label className="profileheddingcls">Dcoument</label>
              <a>
                <IoDocumentAttach
                  onClick={() => {
                    downloadFile(data?.document[0]);
                  }}
                  size={100}
                />
              </a>
            </div>
          ) : null}
          {/* {data?.image ? (
            <div className="col-span-12 md:col-span-12">
              <label className="profileheddingcls">Image</label>
              <div>
                {data?.image?.map((itm) => {
                  return (
                    <div className="imagethumbWrapper">
                      <img
                        src={methodModel.noImg(itm, 'users')}
                        className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null} */}
        </div>
      </div>
    </Layout>
  );
};

export default TransactionViewPage;
